<template>
  <div
    v-if="introSection && Object.keys(introSection).length > 0"
    :class="['intro-block m-bot-6', { 'no-image': !image?.[0] }]"
  >
    <div class="intro-block__text">
      <!--<div
        v-if="introSection.sectionTitle"
        class="title-large2 title"
        v-html="introSection.sectionTitle"
      />-->
      <div
        v-if="introSection.text"
        class="text-medium4 text-content"
        v-html="introSection.text"
      />
    </div>
    <div v-if="image?.[0]" class="intro-block__image">
      <img :src="image?.[0]?.url" :alt="image?.[0]?.title" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  introSection: Object,
  image: Object,
})
</script>

<script>
export default {
  name: 'ListingIntro',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
